import React from 'react';

import './LanguageSelectWrapper.scss';

function LanguageSelectWrapper({ children }) {
  return <div styleName="container">{children}</div>;
}

export default LanguageSelectWrapper;